import { render, staticRenderFns } from "./HeatingRenovation.vue?vue&type=template&id=71ea57d0&scoped=true"
import script from "./HeatingRenovation.vue?vue&type=script&lang=js"
export * from "./HeatingRenovation.vue?vue&type=script&lang=js"
import style0 from "./HeatingRenovation.vue?vue&type=style&index=0&id=71ea57d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ea57d0",
  null
  
)

export default component.exports